import React, { Component } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Moment from "moment";
import {
  CBadge,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDataTable,
  CRow,
  CFormGroup,
  CPagination,
  CLabel,
  CSelect,
  CBreadcrumbItem,
  CInput,
  CButton,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
} from "@coreui/react";

import config from "../../config/config";
import axios from "axios";
import CIcon from "@coreui/icons-react";

const BEARER_TOKEN = localStorage.getItem("userToken");
let priviledgeslist = localStorage.getItem("priviledgeslist");
if (priviledgeslist) {
  priviledgeslist = priviledgeslist.split(",");
}

const getBadge = (status) => {
  switch (status) {
    case "1":
      return "success";
    case "0":
      return "secondary";
    case "2":
      return "warning";
    case "3":
      return "danger";
    default:
      return "primary";
  }
};

//const queryPage = useLocation().search.match(/page=([0-9]+)/, '')

class LdReportCam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      leadlist: [],
      subleadlist: [],
      campaignWise: [],
      makelist: [],
      modellist: [],
      substatuslist: [],
      statuslist: [],
      sourcelist: [],
      subsourcelist: [],
      packlist: [],
      make: "",
      model: "",
      status: "",
      substatus: "",
      city: "",
      param: "",
      state: "",
      zone: "",
      otp_verified: "",
      call_verified: "",
      from_added_date: "",
      to_added_date: "",
      showAdvance: false,
      mobile_number: "",
      lead_id: "",
      customer_name: "",
      customer_id: "",
      lead_type: "",
      sub_source_id: "",
      source_id: "",
      to_followup_date: "",
      from_followup_date: "",
      to_updated_date: "",
      from_updated_date: "",
      dialer_status: "",
      ld_status: "",
      auto_send: "",
      email_id: "",
      totalrecord: "",
      loader: true,
      active_page: 1,
      total_page: 1,
      cityListDealer: [],
      dealerList: [],
      selectCity: null,
      AllDealer: [],
      delaerId: null,
      sourceLeadlistId: null,
      sourceLeadlist: [],
      package: "",
      activeKey: 1,
    };

    this.getSubLeadList = this.getSubLeadList.bind(this);
    // this.getLeadList = this.getLeadList.bind(this);
    this.getMakeList = this.getMakeList.bind(this);
    this.changeMake = this.changeMake.bind(this);
    this.getStatusList = this.getStatusList.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.getSubStatusList = this.getSubStatusList.bind(this);
    this.getSourceList = this.getSourceList.bind(this);
    this.changeText = this.changeText.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.OpenAdvanceFilter = this.OpenAdvanceFilter.bind(this);
    this.getSubSourceList = this.getSubSourceList.bind(this);
    this.changeSource = this.changeSource.bind(this);
    this.changeLead = this.changeLead.bind(this);
    this.ExportLeadData = this.ExportLeadData.bind(this);
    this.spin = this.spin.bind(this);
    this.changeModel = this.changeModel.bind(this);
    this.enterKey = this.enterKey.bind(this);
    this.sourceListId = this.sourceListId.bind(this);
    this.setActiveKey = this.setActiveKey.bind(this);
    this.getLeadSourceList = this.getLeadSourceList.bind(this);

    this.getPackageList = this.getPackageList.bind(this);
  }

  componentDidMount() {
    this.setState({
      loader: false,
    });

    setTimeout(() => {
      this.setState({
        loader: true,
      });
    }, 1000);

    this.getSubLeadList(1, this.state.param);
    //this.getLeadList(this.state.param);
    this.getMakeList();
    this.getStatusList();
    this.getSourceList();
    this.getCityForDrop();
    this.getLeadSourceList();
    this.getPackageList();
  }

  spin() {
    return (
      <div
        style={{
          "text-align": "center",
          display: "flex",
          "justify-content": "center",
          "margin-top": "80px",
        }}
      >
        <img src="/spinner.gif" alt="LOADING..." />
      </div>
    );
  }

  getSubSourceList(source_id) {
    const APIURL =
      config.API_URL + "/source/listsubsource?source_id=" + source_id;

    var bearer = BEARER_TOKEN;
    axios
      .get(APIURL, { headers: { Authorization: bearer } })
      .then((r) => {
        if (r.status == 200) {
          this.setState({ subsourcelist: r.data.data });
        }
      })
      .catch((error) => {
        console.log("API ERR: ");
        console.error(error);
        // res.json({ error: error });
      });
  }

  changeText(e) {
    var name = e.target.name;
    var value = e.target.value;
    this.setState({
      [name]: value,
    });
  }

  getSourceList() {
    const APIURL = config.API_URL + "/source/listsource";

    var bearer = BEARER_TOKEN;
    axios
      .get(APIURL, { headers: { Authorization: bearer } })
      .then((r) => {
        if (r.status == 200) {
          this.setState({ sourcelist: r.data.data });
        }
      })
      .catch((error) => {
        console.log("API ERR: ");
        console.error(error);
        // res.json({ error: error });
      });
  }
  getLeadSourceList() {
    const APIURL = config.API_URL + "/lead/sourcelist";

    var bearer = BEARER_TOKEN;
    axios
      .get(APIURL, { headers: { Authorization: bearer } })
      .then((r) => {
        if (r.status == 200) {
          let data = r.data.data ? r.data.data : [];
          this.setState({ sourceLeadlist: data });
        }
      })
      .catch((error) => {
        console.log("API ERR: ");
        console.error(error);
        // res.json({ error: error });
      });
  }

  getStatusList() {
    const APIURL = config.API_URL + "/subleadstatus/liststatus";

    var bearer = BEARER_TOKEN;
    axios
      .get(APIURL, { headers: { Authorization: bearer } })
      .then((r) => {
        if (r.status == 200) {
          let data = r.data.data ? r.data.data : [];
          this.setState({ statuslist: data });
        }
      })
      .catch((error) => {
        console.log("API ERR: ");
        console.error(error);
        // res.json({ error: error });
      });
  }

  getSubLeadList(currentPage = 1, paramstr = "") {
    let page = currentPage && currentPage > 1 ? currentPage : 1;
    var APIURL = "";
    if (paramstr !== "") {
      APIURL =
        config.API_URL + "/lead/leadssentcampaign?campaign=91wheels" + paramstr;
    } else {
      APIURL = config.API_URL + "/lead/leadssentcampaign?campaign=91wheels";
    }

    var bearer = BEARER_TOKEN;
    axios
      .get(APIURL, { headers: { Authorization: bearer } })
      .then((r) => {
        if (r.status == 200) {
          this.setState({
            subleadlist: r.data.data,
            totalrecord: r.data.paging ? r.data.paging.total_record : 0,
            active_page: page,
            total_page: r.data.paging ? r.data.paging.total_page : 1,
          });
        }
      })
      .catch((error) => {
        console.log("API ERR: ");
        console.log(error);
        // res.json({ error: error });
      });

    console.log(this.state.subleadlist);
  }

  getMakeList() {
    const APIURL = config.API_URL + "/lead/makelist";

    var bearer = BEARER_TOKEN;
    axios
      .get(APIURL, { headers: { Authorization: bearer } })
      .then((r) => {
        if (r.status == 200) {
          let data = r.data.data ? r.data.data : [];
          this.setState({ makelist: data });
        }
      })
      .catch((error) => {
        console.log("API ERR: ");
        console.error(error);
        // res.json({ error: error });
      });
  }

  getModelList(make_id) {
    const APIURL = config.API_URL + "/lead/modellist?make_id=" + make_id;

    var bearer = BEARER_TOKEN;
    axios
      .get(APIURL, { headers: { Authorization: bearer } })
      .then((r) => {
        if (r.status == 200) {
          this.setState({ modellist: r.data.data });
        }
      })
      .catch((error) => {
        console.log("API ERR: ");
        console.error(error);
        // res.json({ error: error });
      });
  }

  getSubStatusList(status_id) {
    const APIURL =
      config.API_URL +
      "/subleadstatus/listsubstatus?page=1&limit=100&status_id=" +
      status_id;

    var bearer = BEARER_TOKEN;
    axios
      .get(APIURL, { headers: { Authorization: bearer } })
      .then((r) => {
        if (r.status == 200) {
          this.setState({ substatuslist: r.data.data });
        }
      })
      .catch((error) => {
        console.log("API ERR: ");
        console.error(error);
        // res.json({ error: error });
      });
  }

  changeMake(e) {
    var name = e.target.name;
    var value = e.target.value;
    this.setState({
      [name]: value,
    });
    this.getModelList(value);
  }

  changeModel(e) {
    var name = e.target.name;
    var value = e.target.value;
    this.setState({
      [name]: value,
    });
  }

  changeLead(e) {
    var name = e.target.name;
    var value = e.target.value;
    this.setState({
      [name]: value,
    });
  }

  changeStatus(e) {
    var name = e.target.name;
    var value = e.target.value;
    this.setState({
      [name]: value,
    });
    this.getSubStatusList(value);
  }
  changeSource(e) {
    var name = e.target.name;
    var value = e.target.value;
    this.setState({
      [name]: value,
    });
    this.getSubSourceList(value);
  }

  enterKey(e) {
    if (e.key === "Enter" || e.keycode === 13) {
      this.searchFilter(e);
    }
  }

  searchFilter(e) {
    e.preventDefault();

    var paramstr = "";

    if (this.state.from_added_date != "") {
      paramstr += "&from_date=" + this.state.from_added_date;
    }

    if (this.state.to_added_date != "") {
      paramstr += "&to_date=" + this.state.to_added_date;
    }

    if (this.state.source_id != "") {
      paramstr += "&source_id=" + this.state.source_id;
    }

    if (this.state.sub_source_id != "") {
      paramstr += "&sub_source_id=" + this.state.sub_source_id;
    }

    if (this.state.make != "") {
      paramstr += "&v_make_id=" + this.state.make;
    }
    if (this.state.delaerId != null) {
      paramstr += "&dealer_id=" + this.state.delaerId;
    }
    if (this.state.sourceLeadlistId != null) {
      paramstr += "&source_id=" + this.state.sourceLeadlistId;
    }
    if (this.state.model != "") {
      paramstr += "&v_model_id=" + this.state.model;
    }
    if (this.state.package != "") {
      paramstr += "&pack_id=" + this.state.package;
    }

    console.log(paramstr);
    this.setState({
      param: paramstr,
    });

    this.getSubLeadList(1, paramstr);
  }

  OpenAdvanceFilter() {
    if (this.state.showAdvance) {
      this.setState({
        showAdvance: false,
      });
    } else {
      this.setState({
        showAdvance: true,
      });
    }
  }

  ExportLeadData() {
    const APIURL =
      config.API_URL + "/lead/exportsubleadData?" + this.state.param;

    var bearer = BEARER_TOKEN;
    axios
      .get(APIURL, { headers: { Authorization: bearer } })
      .then((r) => {
        if (r.status == 200) {
          alert("Sheet has been sent to Register Email ID");
        }
      })
      .catch((error) => {
        console.log("API ERR: ");
        console.error(error);
        // res.json({ error: error });
      });
  }

  getCityForDrop() {
    const APIURL = config.API_URL + "/lead/citylist";

    var bearer = BEARER_TOKEN;
    axios
      .get(APIURL, { headers: { Authorization: bearer } })
      .then((r) => {
        if (r.status == 200) {
          let data = r.data.data ? r.data.data : [];
          this.setState({ cityListDealer: data });
        }
      })
      .catch((error) => {
        console.log("API ERR: ");
        console.error(error);
        // res.json({ error: error });
      });
  }

  getPackageList() {
    const APIURL = config.API_URL + "/package/listPackages?limit=50";

    var bearer = BEARER_TOKEN;
    axios
      .get(APIURL, { headers: { Authorization: bearer } })
      .then((r) => {
        if (r.status == 200) {
          let data = r.data.data ? r.data.data : [];
          this.setState({ packlist: data });
        }
      })
      .catch((error) => {
        console.log("API ERR: ");
        console.error(error);
        // res.json({ error: error });
      });
  }

  sourceListId(e) {
    var value = e.target.value;
    this.setState({
      sourceLeadlistId: value,
    });
  }

  setActiveKey(ctr) {
    this.setState({ activeKey: ctr });
  }
  render() {
    console.log(this.state.from_added_date);
    var tp = "";

    if (this.state.totalrecord && this.state.totalrecord !== "") {
      tp = this.state.totalrecord;
    }
    return this.state.loader === true ? (
      <>
        <CRow>
          <CCol xl={12}>
            <CCard>
              <CCardHeader>
                LD
                <small className="text-muted"> Report Campaign Wise</small>
                {/* <CButton  className="float-right" type="button" color="success" 
  onClick={this.ExportLeadData}>Export Data</CButton> */}
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol xs="3">
                    <CFormGroup>
                      <CLabel htmlFor="package">
                        Package<sup className="text-danger bold">*</sup>
                      </CLabel>
                      <CSelect
                        custom
                        name="package"
                        id="package"
                        onChange={this.changeStatus}
                        value={this.state.package}
                      >
                        <option value="">Select Package</option>
                        {this.state.packlist.map((pack) => {
                          return (
                            <option value={pack.pack_id}>
                              {pack.pack_name}
                            </option>
                          );
                        })}
                      </CSelect>
                    </CFormGroup>
                  </CCol>
                  {/* <CCol xs="3">
                <CFormGroup>
                  <CLabel htmlFor="source">Select Source</CLabel>
                  <CSelect custom name="source" id="source" onChange={this.sourceListId} value={this.state.sourceLeadlistId}>
                    <option value="">Select Source</option>
                    {this.state.sourceLeadlist.map(status => {
                      return (
                        <option value={status.item_id}>{status.item_text}</option>
                      )
                    })
                    }
                  </CSelect>
               </CFormGroup>
              </CCol> */}

                  {/* <CCol xs="3">
                <CFormGroup>
                  <CLabel htmlFor="ccmonth">Make</CLabel>
                  <CSelect custom name="make" id="make" onChange={this.changeMake} value={this.state.make}>
                    <option value="">Select Make</option>
                    {this.state.makelist.map(make => {
                      return (
                        <option value={make.item_id}>{make.item_text}</option>
                      )
                    })
                    }


                  </CSelect>
                </CFormGroup>
              </CCol>
            
              <CCol xs="3">
                <CFormGroup>
                  <CLabel htmlFor="ccyear">Model</CLabel>
                  <CSelect custom name="model"  onChange={this.changeModel} value={this.state.model}>
                    <option value="">Select Model</option>
                    {this.state.modellist.map(model => {
                      return (
                        <option value={model.item_id}>{model.item_text}</option>
                      )
                    })
                    }
                  </CSelect>
                </CFormGroup>
              </CCol> */}

                  <CCol xs="3">
                    <CFormGroup>
                      <CLabel htmlFor="from_added_date">
                        Lead Sent From Date
                      </CLabel>
                      <CInput
                        type="date"
                        name="from_added_date"
                        id="from_added_date"
                        value={this.state.from_added_date}
                        onChange={this.changeText}
                      />
                    </CFormGroup>
                  </CCol>

                  <CCol xs="3">
                    <CFormGroup>
                      <CLabel htmlFor="to_added_date">Lead Sent To Date</CLabel>
                      <CInput
                        type="date"
                        name="to_added_date"
                        id="to_added_date"
                        value={this.state.to_added_date}
                        onChange={this.changeText}
                      />
                    </CFormGroup>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol xs="4" className="mb-4">
                    <CButton
                      type="button"
                      className="ml-2"
                      size="sm"
                      color="primary"
                      onClick={this.searchFilter}
                    >
                      <CIcon name="cil-user" /> Search
                    </CButton>{" "}
                    <CButton
                      className="ml-2"
                      type="reset"
                      size="sm"
                      color="danger"
                      onClick={() => window.location.reload()}
                    >
                      <CIcon name="cil-ban" /> Clear
                    </CButton>
                  </CCol>
                </CRow>

                <CDataTable
                  items={this.state.subleadlist}
                  fields={[
                    "lead_sent_date",
                    ,
                    "Total_Pushed",
                    "Total_failed",
                    "total_leads",
                  ]}
                  hover
                  striped
                  itemsPerPage={1000}
                  activePage="1"
                  clickableRows
                  onRowClick=""
                  scopedSlots={{
                    model_name: (item) => <td>{item.v_model_display_name}</td>,

                    action: (item) => (
                      <td>
                        {priviledgeslist &&
                        priviledgeslist.indexOf("3") >= 0 ? (
                          <a
                            href={
                              "/#/subleads/" +
                              item.lead_id +
                              "/" +
                              item.sub_lead_id
                            }
                          >
                            <CIcon name="cil-pencil"></CIcon>
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </td>
                    ),
                    lead_date: (item) => (
                      <td>{Moment(item.lead_date).format("DD MMMM YYYY")}</td>
                    ),
                  }}
                />
                {/* <CPagination className="float-left" activePage={this.state.active_page} limit={10} pages={this.state.total_page} onActivePageChange={(page) => this.getSubLeadList(page,this.state.param)}/> */}
                <CCol xs="2" className="float-right">
                  <CBreadcrumbItem className="">
                    {" "}
                    Total Records : {this.state.subleadlist.length}
                  </CBreadcrumbItem>
                </CCol>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </>
    ) : (
      this.spin()
    );
  }
}

export default LdReportCam;
